export default __webpack_public_path__ + "static/media/icons8-folder.a6986bf7.svg";